import { render } from "./Index.vue?vue&type=template&id=7be40f9f&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=7be40f9f&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7be40f9f"]])

export default __exports__